import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { getRouteLink } from '../../helpers/helpers'

// Verbs should be rendered fancy
const renderVerb = verb => {
	return <span className={`verb-${verb}`}>{verb}</span>
}

const renderLinkText = route => {
	if (route.verbs.length > 1) {
		return (
			<span>
				<span className="verb-multi">MULTI</span> {route.path[0].substring(3)}
			</span>
		)
	}

	return (
		<span>
			{renderVerb(route.verbs[0])} {route.path[0].substring(3)}
		</span>
	)
}

class RouteLink extends React.PureComponent {
	shouldComponentUpdate(nextProps) {
		if (this.props.hash === nextProps.hash) return false

		// If the hash changes, just render all of them. Who cares?
		return true
	}
	render() {
		const { route, hash } = this.props
		const link = getRouteLink(route)
		const hashMatch = hash === `#${link}` ? 'active-route' : ''
		return (
			<a href={`#${link}`} key={link} className={hashMatch}>
				{renderLinkText(route)}
			</a>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const { location } = ownProps
	return {
		hash: location.hash,
	}
}

RouteLink.propTypes = {
	route: PropTypes.object.isRequired,
	hash: PropTypes.string,
}

export default withRouter(connect(mapStateToProps)(RouteLink))



// WEBPACK FOOTER //
// ./src/components/api/RouteLink.js